import { useState } from "react";
import CrmInsurance from "./CrmInsurance";
import InsuranceMisAnalytics from "./InsuranceMisAnalytics";
import  InsuranceClaims  from "./InsuranceClaims";

const InsuranceParent = () => {
  const [cardName, setCardValue] = useState("Insurance");
  const handleActiveCard = (cardName) => {
    setCardValue(cardName);
  };

  return (
    <>
      <div className="radio-inputs" style={{ marginTop: "-10px" }}>
        <label className="radio">
          <div onClick={() => handleActiveCard("Insurance")}>
            <input
              type="radio"
              name="radio"
              checked={cardName === "Insurance" ? true : false}
            />
            <span
              className={`name ${
                cardName === "Insurance" ? "fw-bold text-primary" : "fw-bold"
              }`}
            >
              Policies
            </span>
          </div>
        </label>
        <label className="radio">
          <div onClick={() => handleActiveCard("analytics")}>
            <input
              type="radio"
              name="radio"
              checked={cardName === "analytics" ? true : false}
            />
            <span
              className={`name ${
                cardName === "analytics" ? "fw-bold text-primary" : "fw-bold"
              }`}
            >
              Analytics
            </span>
          </div>
        </label>
        <label className="radio">
          <div onClick={() => handleActiveCard("claims")}>
            <input
              type="radio"
              name="radio"
              checked={cardName === "claims" ? true : false}
            />
            <span
              className={`name ${
                cardName === "claims" ? "fw-bold text-primary" : "fw-bold"
              }`}
            >
              Claims
            </span>
          </div>
        </label>
      </div>

      {cardName === "Insurance" ? (
        <CrmInsurance />
      ) : cardName === "analytics" ? (
        <InsuranceMisAnalytics />
      ) : (
        <InsuranceClaims />
      )}
    </>
  );
};

export default InsuranceParent;
